import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentUpdateTitle: {
    defaultMessage: 'Payment Details',
    description: 'Title for the payment update modal',
    id: 'S/JtQ5',
  },
  paymentMethodLabel: {
    description: 'Label for payment method section',
    defaultMessage: 'Payment Method',
    id: 'jefKiG',
  },
  selectPaymentMethod: {
    description: 'Label for selecting an existing payment method',
    defaultMessage: 'Use existing',
    id: 'UBF3Zw',
  },
  addPaymentMethod: {
    description: 'Label for adding a new payment method',
    defaultMessage: 'Add new',
    id: '1389no',
  },
  editSubscriptionBilling: {
    description: 'Edit Subscription Billing modal title',
    defaultMessage: 'Edit Subscription Billing',
    id: 'GHvLmC',
  },
  editShipstationBalance: {
    description: 'Edit ShipStation Balance modal title',
    defaultMessage: 'Edit ShipStation Balance',
    id: 'Dzik1e',
  },
  cancel: {
    description: 'Cancel making billing update',
    defaultMessage: 'Cancel',
    id: '7ztVO2',
  },
  continueToBank: {
    description: 'Continue to bank for Pay by Bank payment method',
    defaultMessage: 'Continue with Pay by Bank',
    id: 'Qey+ek',
  },
  save: {
    description: 'Save changes to payment method',
    defaultMessage: 'Save',
    id: 'YmhMh4',
  },
  selectPaymentMethodPlaceholder: {
    id: '8DqB6t',
    defaultMessage: 'Select a payment method',
    description: 'Placeholder text for the payment method selection dropdown',
  },
  noPaymentMethodsAvailable: {
    id: 'pwbUm9',
    defaultMessage: 'No payment methods available',
    description: 'Message shown when no payment methods are available to select',
  },
  paymentDetailsSuccessTitle: {
    description: 'Title letting the user know we successfully processed their payment details',
    defaultMessage: 'Successfully Processed Payment Details',
    id: 'XYKrVw',
  },
  paymentDetailsSuccessMessage: {
    description: 'Message letting the user know we successfully processed their payment details',
    defaultMessage: 'Your payment details have been successfully processed',
    id: 'hInUQ4',
  },
  paymentDetailsErrorTitle: {
    description: 'Title letting the user know we encountered an error processing their payment details',
    defaultMessage: 'Error Processing Payment Details',
    id: 'swMRDG',
  },
  paymentDetailsErrorMessage: {
    description: 'Message letting the user know we encountered an error processing their payment details',
    defaultMessage:
      'We encountered an error processing your payment details. Please review your payment details and try again. If this issue persists please try a different payment method or contact our support team 24/7 at support@shipstation.com or by phone Monday - Friday 8AM - 6PM CST at 1(888)893-3885 for additional assistance.',
    id: 'PG9eOe',
  },
  taxUpdateErrorTitle: {
    description: 'Title for tax update error',
    defaultMessage: 'Error Saving Tax Form',
    id: 'XdP8cu',
  },
  taxUpdateErrorMessage: {
    description: 'Message for tax update error',
    defaultMessage: 'We encountered an error saving your tax form. Please try again.',
    id: 'Bfm+zq',
  },
});
